/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Card, Input, Button, TrashIcon } from '@avila-tek/ui/src';
import { FormHeader } from '../shared/Forms';
import { useNotify } from '../../hooks';

interface ArrayInputProps {
  array: string[];
  setArray: React.Dispatch<React.SetStateAction<string[]>>;
  title: string;
  itemName: string;
  example: string;
}

function ArrayInput({
  array,
  setArray,
  title,
  itemName,
  example,
}: ArrayInputProps) {
  const notify = useNotify();
  const [newPosition, setNewPosition] = React.useState('');

  const addNewPosition = () => {
    // validate position not in structure
    if (array.includes(newPosition)) {
      return notify('Ya se encuentra incluido', 'error');
    }

    if (!newPosition) {
      return notify('Ingrese lo que desea agregar a la lista', 'error');
    }

    setArray([...array, newPosition]);
    setNewPosition('');
  };

  const removePosition = (position: string) => {
    // validate position in structure
    if (!array.includes(position)) {
      return notify('La posición no existe', 'error');
    }

    setArray(array.filter((p) => p !== position));
  };

  return (
    <Card>
      <FormHeader backBtnText="" title={title} />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full flex flex-col">
            <h3 className="text-purple-300 font-semibold mx-auto capitalize">
              Agregar nuevo {itemName}
            </h3>
            <Input
              value={newPosition ?? ''}
              label={`Nombre del ${itemName}`}
              type="text"
              placeholder="Ingrese el cargo"
              onChange={(e) => {
                e.preventDefault();
                setNewPosition(e.target.value);
              }}
            />
            <span className="text-sm text-neutral-400">
              {`Ejemplo: ${example}`}
            </span>
            <div className="mt-5 flex">
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  addNewPosition();
                }}
              >
                Agregar
              </Button>
            </div>
          </div>
          <div className="w-full flex flex-col ">
            <h3 className="text-purple-300 font-semibold mx-auto">
              Lista de {itemName}
            </h3>
            <ul className="md:ml-10 marker:text-purple-300 mx-10">
              {array.map((position) => (
                <li className="list-disc " key={position}>
                  <div className="flex items-center my-1">
                    {position}
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        removePosition(position);
                      }}
                    >
                      <TrashIcon className="w-6 h-6 text-danger-200 ml-2" />
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ArrayInput;
